// removed by extract-text-webpack-plugin
module.exports = {"container":"Loader__container___2h9Ic","spinner":"Loader__spinner___1Mikz","sk-bouncedelay":"Loader__sk-bouncedelay___dxPpy","_light":"Loader___light___1gJfk","loadText":"Loader__loadText___qA_2-","bounce1":"Loader__bounce1___4dmhV","bounce2":"Loader__bounce2___3RFJw"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/views/BaseElements/Loader/Loader.css
 ** module id = 715
 ** module chunks = 0
 **/